import { ChargeAmount } from '@generated/gql/graphql';

const getAnnualCharge = (monthlyCharge: ChargeAmount): ChargeAmount => ({
  ...monthlyCharge,
  value: (Number(monthlyCharge.value) * 12).toString(),
});

export { getAnnualCharge };
